module.exports = __webpack_public_path__ + "img/juan.e7d8259c.png";